<template>
	<div>
		<h1>Groupes utilisateurs</h1>

		<b-table striped hover :items="groups" :fields="fields">
			<template v-slot:cell(uid)="data">
				<router-link
					:to="{ name: 'groupe', params: { id: data.value } }"
					><i class="fas fa-edit"></i
				></router-link>
			</template>
		</b-table>

		<b-button @click="newGroup()">Nouveau groupe</b-button>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";

	import store from "../store";
	import client from "../services/client.js";

	export default {
		names: "groups",
		data() {
			return {
				groups: [],
				fields: [
					{
						key: "name",
						label: "Nom",
						sortable: true,
					},
					{
						key: "uid",
						label: "",
					},
				],
			};
		},
		methods: {
			newGroup() {
				this.$router.push({
					name: "groupe",
					params: { id: this.$uuid.v4() },
				});
			},
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.groupes) {
				this.$router.push({ name: "profile" });
			}

			this.groups = await client.getClientGroups();
		},
	};
</script>

<style></style>
